<template>
  <v-dialog v-model="dialog" fluid>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Sync Stocks</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container>
        <div style="display: flex; gap: 10px; flex-direction: column;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-autocomplete v-model="selectedStock" label="Select Stock" item-value="stock_code" outlined dense
                            hide-details="auto" :items="stocks" return-object item-text="product_name">
              <template v-slot:selection="{ item }">
                <div>{{ item.stock_code }}</div>
              </template>
              <template v-slot:item="{ item }">
                <div style="display: flex; gap: 2px; align-items: center;">
                  <div class="text-caption">
                    {{ item.stock_code }}
                  </div>
                  -
                  <strong>{{ item.product_name }}</strong>
                </div>
              </template>
            </v-autocomplete>
            <v-btn color="primary" dark @click="addItem">
              Add
            </v-btn>
          </div>
          <v-data-table :headers="headers" :items="items" :items-per-page="10"
                        :footer-props="{ itemsPerPageOptions: [10, 20, 50] }" :loading="tableLoading" class="mt-4">
            <template v-slot:item.actions="{ item }">
              <v-btn text color="red" @click="removeItem(item.id)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from 'vuex/dist/vuex.common.js'
import appAxios from '../../../../extra-functions/axios.extra'
import { ConfirmPopup, ErrorPopup, LoadingPopup, SuccessPopup } from '../../../../lib/utils'

export default {
  name: 'SyncStocks',
  data() {
    return {
      dialog: false,
      headers: [
        { text: 'Product Name', value: 'product_name' },
        { text: 'Stock Code', value: 'stock_code' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      wholeSaleId: null,
      items: [],
      itemsCount: 0,
      tableLoading: false,
      selectedStock: null,
      stocks: [],
      stocksCount: 0,
    }
  },
  watch: {
    wholeSaleId() {
      this.fetchWholeStocks()
    },
  },
  created() {
    this.fetchStocks()
  },
  computed: {
    ...mapState({
      authToken: state => state.auth.token,
    }),
  },
  methods: {
    openDialog(wholeSaleId) {
      if (!wholeSaleId) {
        this.dialog = false
        return
      }
      this.dialog = true
      this.wholeSaleId = wholeSaleId
    },
    async addItem() {
      try {
        const response = await appAxios(this.authToken).post(`/whole-sales/${this.wholeSaleId}/stocks`, {
          stock_id: this.selectedStock.id,
        })
        SuccessPopup.fire({
          title: 'Success',
          text: 'Item added successfully.',
        })
        this.fetchWholeStocks()
        this.fetchStocks()
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Error adding item:', e)
        }
        ErrorPopup.fire({
          title: 'Error',
          text: 'Failed to add item. Please try again later.',
        })
      }
    },
    async removeItem(stockId) {
      try {
        const result = await ConfirmPopup.fire({
          title: 'Confirm',
          html: `
            <p>Are you sure you want to remove this item?</p>
          `,
        })
        if (!result.isConfirmed) return
        const response = await appAxios(this.authToken).delete(`/whole-sales/${this.wholeSaleId}/stocks/${stockId}`)
        SuccessPopup.fire({
          title: 'Success',
          text: 'Item removed successfully.',
        })
        this.fetchWholeStocks()
        this.fetchStocks()
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Error removing item:', e)
        }
        ErrorPopup.fire({
          title: 'Error',
          text: 'Failed to remove item. Please try again later.',
        })
      }
    },
    async fetchWholeStocks() {
      try {
        LoadingPopup.fire({
          title: 'Loading',
          text: 'Fetching whole stocks...',
        })
        this.tableLoading = true
        const { data: { data: items, count } } = await appAxios(this.authToken).get(`/whole-sales/${this.wholeSaleId}/stocks`)
        this.items = items
        this.itemsCount = count
        LoadingPopup.close()
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Error fetching whole stocks:', e)
        }
        ErrorPopup.fire({
          title: 'Error',
          text: 'Failed to fetch whole stocks. Please try again later.',
        })
      } finally {
        this.tableLoading = false
      }
    },
    async fetchStocks() {
      try {
        const { data: { data: items, count } } = await appAxios(this.authToken).get('/stocks/whole-sale-options')
        this.stocks = items
        this.stocksCount = count
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Error fetching stocks:', e)
        }
        ErrorPopup.fire({
          title: 'Error',
          text: 'Failed to fetch stocks. Please try again later.',
        })
      }
    },
  },
}
</script>
